// components/ConfirmDialog.jsx
import React from "react";
import { HiOutlineExclamationCircle } from "react-icons/hi";

export default function ConfirmDialog({
  isOpen,
  onClose,
  onConfirm,
  title = "Konfirmasi",
  message = "Apakah Anda yakin?",
  confirmText = "Ya",
  cancelText = "Batal",
}) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 backdrop-blur-sm">
      <div className="w-full max-w-sm p-6 bg-white shadow-lg rounded-xl animate-fadeIn">
        {/* Icon & Title */}
        <div className="flex items-center gap-3 mb-4">
          <HiOutlineExclamationCircle className="text-3xl text-green-600" />
          <h2 className="text-xl font-semibold text-green-700">{title}</h2>
        </div>

        {/* Message */}
        <p className="mb-6 text-gray-600">{message}</p>

        {/* Actions */}
        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-3 py-1 text-green-700 transition-colors bg-green-100 rounded-md hover:bg-green-200"
          >
            {cancelText}
          </button>
          <button
            onClick={() => {
              onConfirm();
              onClose();
            }}
            className="px-4 py-1 text-white transition-colors bg-green-600 rounded-md hover:bg-green-700"
          >
            {confirmText}
          </button>
        </div>
      </div>

      {/* Simple Animation */}
      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: scale(0.95);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }
        .animate-fadeIn {
          animation: fadeIn 0.2s ease-out;
        }
      `}</style>
    </div>
  );
}
